import { FunctionComponent, ReactNode } from "react";

import { useParams } from "react-router-dom";

import { Permission, SecurityArea } from "../../auth/index.ts";
import { useEngagementAppPermissions } from "../../hooks/index.ts";

import { RouteGuard } from "./RouteGuard.tsx";

interface Props {
    securityArea?: SecurityArea;
    hasAny?: Permission[];
    render: ReactNode;
}

export const EngagementRouteGuard: FunctionComponent<Props> = ({ securityArea, hasAny, render }) => {
    const { engagementId: engagementIdParam } = useParams();
    const appPermissions = useEngagementAppPermissions(engagementIdParam);

    if (!engagementIdParam) {
        throw new Error("EngagementRouteGuard: engagementId is required.");
    }

    return <RouteGuard appPermissions={appPermissions} securityArea={securityArea} hasAny={hasAny} render={render} />;
};
